/**
 * CSS injection utility
 * Injects the component's CSS into the document head once.
 * This is to avoid issues with multiple React roots or SSR
 * and doesn't require the user of the library to manage CSS imports.
 */

const STYLE_ID = 'weavable-react-styles';
let injected = false;

export function injectStyles(cssString: string): void {
    // Only inject once, even if multiple providers are mounted
    if (injected || typeof document === 'undefined') {
        return;
    }

    // Check if styles already exist (e.g., from SSR or previous mount)
    if (document.getElementById(STYLE_ID)) {
        injected = true;
        return;
    }

    // Create and inject style tag
    const styleTag = document.createElement('style');
    styleTag.id = STYLE_ID;
    styleTag.textContent = cssString;
    document.head.appendChild(styleTag);

    injected = true;
}

/**
 * Check if styles have been injected
 */
export function stylesInjected(): boolean {
    return injected || (typeof document !== 'undefined' && document.getElementById(STYLE_ID) !== null);
}
